import React from 'react';
import { Image, Linking, Platform } from 'react-native';
import { isSafari, isChrome, isIOS } from 'react-device-detect';
import type { LocationProps, PlayerAddressProps } from '../types';
import * as Location from 'expo-location';
import { Button, Text, View } from '../Components/Themed';
import { useColors } from '../constants/useColors';

type LocationTrackerProps = {
    onClose: () => void,
    permission: {
        checked:boolean,
        permission?: Location.PermissionStatus | 'prompt'
    },
    onPromptForPermission:() => void, 
    location: {
        loading: boolean,
        error?:string,
        coordinates:any,
        address_results:any[],
        player_address?:PlayerAddressProps,
        region?:string,
        location?:LocationProps
    }
    onGetLocation: () => void
}
const LocationTracker = ({ onClose, onGetLocation, permission, location, onPromptForPermission }: LocationTrackerProps) => {
    const Colors = useColors();
    const { loading, error } = location;

    const handleHelpMe = () => {
        if(Platform.OS == 'ios'){ return Linking.openURL('app-settings:'); }
        if(isSafari && isIOS){ return Linking.openURL('https://support.bettoredge.com/hc/en-us/articles/1500010390982-How-do-I-turn-on-Location-Settings-for-Apple-Safari') }
        if(isChrome && isIOS){ return Linking.openURL('https://support.bettoredge.com/hc/en-us/articles/1500010423381-How-do-I-turn-on-Location-Settings-for-Android-Chrome') }
        return Linking.openURL('https://support.bettoredge.com/hc/en-us/articles/1500010423381-How-do-I-turn-on-Location-Settings-for-Android-Chrome')
    }


    return (
        <View>
            {permission.permission == 'undetermined' || permission.permission == 'prompt' || !permission.permission ?
            <View style={{ padding:20 }}>
                <View style={{ padding:10 }}>
                    <Text size={18} theme='h2'>ALL REAL-MONEY TRANSACTIONS REQUIRE LOCATION</Text>
                </View>
                <View style={{ justifyContent:'center', alignItems:'center', padding:15 }}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1696434494/loc_icon_qdkurk.png' }}
                        style={{ width: 80, height: 80 * 1.232 }}
                    />
                </View>
                <View style={{ padding:10 }}>
                    <Text style={{ marginTop:5 }} size={14} theme='description' textAlign='center'>When using real money, either in the form of a bet, competition or deposit/withdrawal, BettorEdge requires location services turned on to verify you are in a location where betting is permitted.</Text>
                </View>
            </View>
            : permission.permission == 'denied' ?
            <View style={{ padding:20 }}>
                <View style={{ padding:10 }}>
                    <Text size={18} theme='h2' textAlign='center'>LOCATION SETTINGS ARE NOT ENABLED</Text>
                </View>
                <View style={{ justifyContent:'center', alignItems:'center', padding:15 }}>
                    <Image
                        source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1696434494/loc_icon_qdkurk.png' }}
                        style={{ width: 80, height: 80 * 1.232 }}
                    />
                </View>
                <View style={{ padding:10 }}>
                    <Text style={{ marginTop:5 }} size={14} theme='warning' textAlign='center'>{error ?? `We were not able to get your location.  Please use the Help Me button below to troubleshoot enabling your device's location services`}</Text>
                </View>
            </View>
            : permission.permission == 'granted' || location.location ?
            <View style={{ padding:20 }}>
                <View style={{ padding:10 }}>
                    <Text size={18} theme='h2' textAlign='center'>ALL REAL-MONEY TRANSACTIONS REQUIRE LOCATION</Text>
                </View>
                <View style={{ justifyContent:'center', alignItems:'center', padding:15 }}>
                    <Image
                        source={{ uri: location.location?.location_image }}
                        style={{ width: 100, height: 100 }}
                    />
                </View>
                <View style={{ padding:10 }}>
                    <Text style={{ marginTop:5 }} theme='description' size={14} weight='regular' textAlign='center'>When using real money, either in the form of a bet, competition or deposit/withdrawal, BettorEdge requires location services turned on to verify you are in a location where betting is permitted.</Text>
                </View>
            </View>
            :<></>}
            { permission.permission != 'denied' ?
            <View nativeID='action_row' style={{ flexDirection:'row', padding:20 }}>
                <Button 
                    title='CLOSE'
                    type='close'
                    style={{ flex:1, marginRight:5 }}
                    onPress={() => onClose()}
                />
                <Button
                    title={permission.permission == 'prompt' || permission.permission == 'undetermined' || !permission.checked ? 'PROMPT FOR LOCATION' : 'UPDATE LOCATION'}
                    style={{ flex:3, opacity: loading ? 0.5 : 1 }}
                    loading={loading}
                    disabled={loading}
                    backgroundColor={Colors.text.highlight}
                    title_color={Colors.text.white}
                    onPress={() => {
                        if(permission.permission == 'prompt' || permission.permission == 'undetermined' || !permission.checked){
                            return onPromptForPermission()
                        } else {
                            return onGetLocation()
                        }
                    }}
                />
            </View>
            :
            <View nativeID='action_row' style={{ flexDirection:'row', padding:20 }}>
                <Button 
                    title='CLOSE'
                    type='error'
                    style={{ flex:1, marginRight:5 }}
                    onPress={() => onClose()}
                />
                <Button 
                    title='HELP ME'
                    style={{ flex:3 }}
                    title_color={Colors.text.white}
                    backgroundColor={Colors.text.highlight}
                    onPress={() => handleHelpMe()}
                />
            </View>
            }
        </View>
    )
}

export default LocationTracker